import { InputAdornment, TextField, type TextFieldProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

type WizardTextFieldProps = Omit<TextFieldProps, 'variant'> & {
  prefix?: string
  suffix?: string
}

/** Affexy-styled text input: white field, 1.5px border, 12px radius. */
export default function WizardTextField({ prefix, suffix, multiline, slotProps, ...rest }: WizardTextFieldProps) {
  const theme = useTheme()
  const c = theme.affexy.colors

  return (
    <TextField
      variant="outlined"
      fullWidth
      multiline={multiline}
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: prefix ? (
            <InputAdornment position="start" sx={{ color: c.ink48 }}>
              {prefix}
            </InputAdornment>
          ) : undefined,
          endAdornment: suffix ? (
            <InputAdornment position="end" sx={{ color: c.ink56 }}>
              {suffix}
            </InputAdornment>
          ) : undefined,
        },
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          bgcolor: '#fff',
          borderRadius: '12px',
          fontSize: 14,
          ...(multiline ? {} : { height: 44 }),
          '& fieldset': { borderColor: c.ink08, borderWidth: 1.5 },
          '&:hover fieldset': { borderColor: c.ink32 },
          '&.Mui-focused fieldset': { borderColor: c.coral },
        },
      }}
      {...rest}
    />
  )
}
